import type { Epic } from 'redux-observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import defaultsDeep from 'lodash/defaultsDeep';
import { Observable } from 'rxjs/Observable';
import type { Action } from '../state/actions.tsx';
import { PATCH_QUERY } from '../state/query/actions.tsx';
import { getQuery, getOnQueryChanged } from '../state/query/selectors.tsx';
import type { State } from '../state/reducer.tsx';

export const queryPatched: Epic<Action, State> = (action$, store) =>
	action$.ofType(PATCH_QUERY).mergeMap(({ payload }) => {
		const state = store.getState();
		const callback = getOnQueryChanged(state);

		if (typeof callback === 'function') {
			callback(defaultsDeep(payload, getQuery(state)));
		}

		return Observable.empty<never>();
	});
